export enum authenticationPreferences {
    None = 'NONE',
    NIF = 'NIF',
    CIF = 'CIF',
    Tlf = 'TLF',
    TlfMail = 'TLFMAIL',
    OTP = 'OTP',
    Custom = 'CUSTOM'
}
